/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-07-21 18:05:55
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-07-21 18:22:21
 * @FilePath: \crm-product\found\views\tpm\views\budget\budget_fee\file\detail.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import BasePage from '@/found/components/table_page';
import { download } from '@/found/utils/index';

export default {
  name: 'detail',
  extends: BasePage,
  props: {
    paramsProps: Object,
  },
  data() {
    return {
      params: {
        batchId: this.paramsProps.batchId,
      },
    };
  },
  methods: {
    modalClick({
      val,
      row,
    }) {
      if (val.code === 'download_file') {
        if (!row.url) {
          return this.$message.error('文件不存在');
        }
        download(`/upload/downloadController/download?objectName=${row.objectName}`, row.objectName);
      }
    },
  },
  created() {
    this.getConfigList('file-list');
  },
};
